/* eslint-disable @typescript-eslint/no-explicit-any */
import _ from 'lodash';

import { SharedAppConstants } from '@tock/shared-app-constants';
import protos from 'utils/protos';

const { UrgentHelpRequest } = protos;

export function requestHelp(
  formValues: any,
  currentBuildNumber = 'undefined',
  newBuildNumber = 'undefined'
): ApiAction {
  const values = _.assign({}, formValues, {
    currentBuildNumber,
    newBuildNumber,
  });
  const request = UrgentHelpRequest.fromObject(values);

  return {
    TockApi: {
      postProto: '/business/help',
      request,
      type: SharedAppConstants.NULL,
      toast: 'Your support request has been sent. We will respond as soon as we can.',
    },
  };
}
